import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: false, 
      staleTime: 60000, 
      cacheTime: 300000, 
      refetchOnWindowFocus: false, 
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
     <QueryClientProvider client={queryClient}>
    <App />
    </QueryClientProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
